import { useEffect } from "react";

export function useSEO({ title, description, canonical, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    if (image) setMeta("og:image", image, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (image) setMeta("twitter:image", image);
    setCanonical(canonical || window.location.href);
    setJsonLd(jsonLd);
  }, [title, description, canonical, image, JSON.stringify(jsonLd)]);
}

function setMeta(name, content, og = false) {
  if (!content) return;
  const attr = og ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  // Remove any previous JSON-LD blocks
  document.querySelectorAll('script[data-wf-jsonld="1"]').forEach((n) => n.remove());
  if (!data) return;
  const blocks = Array.isArray(data) ? data : [data];
  blocks.filter(Boolean).forEach((block) => {
    const el = document.createElement("script");
    el.setAttribute("data-wf-jsonld", "1");
    el.type = "application/ld+json";
    el.text = JSON.stringify(block);
    document.head.appendChild(el);
  });
}
